<script lang="ts">
    import ContextName from './ContextName.svelte';
    import {contextService} from './services';

    export let entity: {contextId: string};
</script>

<span style="padding: 0 10px">
    {#if entity && entity.contextId !== contextService.getContextId()}
        <ContextName id={entity.contextId} />
    {/if}
</span>